const BuildingCardSkeleton = () => {
  return (
    <div className="md:shadow-none flex animate-pulse flex-col gap-3 rounded-lg bg-muted-foreground p-4 shadow-md md:bg-transparent md:p-0">
      {/* Simulate the space for the Avatar and icons */}
      <div className="flex justify-between">
        <div className="h-6 w-6 rounded-full bg-muted-foreground/50"></div>
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 rounded-full bg-muted-foreground/50"></div>
          <div className="h-4 w-10 rounded-lg bg-muted-foreground/50"></div>
        </div>
      </div>
      {/* Simulate the space for the building id */}
      <div className="mt-2 h-4 w-full rounded-sm bg-muted-foreground/50"></div>
      {/* Simulate the image */}
      <div className="mt-3 h-48 rounded-lg bg-muted-foreground/50"></div>
      {/* Simulate the building address and price */}
      <div className="mt-3 flex flex-col">
        <div className="h-6 w-1/2 rounded-sm bg-muted-foreground/50"></div>
        <div className="mt-2 h-4 w-3/4 rounded-sm bg-muted-foreground/50"></div>
      </div>
      {/* Simulate the footer */}
      <div className="mt-3 flex flex-col gap-2">
        <div className="rounded-sm border p-2">
          <div className="h-4 rounded-sm bg-muted-foreground/50"></div>
        </div>
        <div className="flex justify-between">
          <div className="h-4 w-1/3 rounded-sm bg-muted-foreground/50"></div>
          <div className="h-4 w-1/4 rounded-sm bg-muted-foreground/50"></div>
        </div>
      </div>
    </div>
  );
};

export const BuildingSkeleton = () => {
  return (
    <div className="z-10 grid w-full grid-cols-1 gap-4 md:grid-cols-1 md:rounded-lg md:p-5 md:shadow-md lg:grid-cols-1">
      {Array(3)
        .fill(1)
        .map((_, index) => (
          <BuildingCardSkeleton key={index} />
        ))}
    </div>
  );
};

export default BuildingSkeleton;
